import { FormNameEnum, useOrgFormResponseQuery } from '@alice-financial/alice-sdk'
import { useOrgId } from '../useOrgId'
import { FormStatus } from '../../survey/types'

export const useCurrentOrgFormFields = (formName: FormNameEnum, formVersion: number) => {
  const orgId = useOrgId()
  return useOrgFormFields(orgId, formName, formVersion)
}

export const useOrgFormFields = (orgId: number, formName: FormNameEnum, formVersion: number) => {
  const { data: formResponseData } = useOrgFormResponseQuery({
    id: orgId,
    formName,
    formVersion,
  })
  return formResponseData?.organization?.formResponse?.formFields
}

export const useOrgFormStatus = (orgId: number, formName: FormNameEnum, formVersion: number): FormStatus => {
  const { data: formResponseData } = useOrgFormResponseQuery({
    id: orgId,
    formName,
    formVersion,
  })
  if (!formResponseData) return 'notStarted'
  const isMarkedComplete = formResponseData?.organization?.formResponse?.complete
  if (isMarkedComplete) return 'complete'
  const formFields = formResponseData?.organization?.formResponse?.formFields
  if (formFields && formFields.every((field) => field.answer)) return 'complete'
  return 'inProgress'
}
